<template>
  <v-row v-if="skippedAssignments.length > 0">
    <v-col cols="12">
      <v-alert type="warning" dense text class="mb-0">
        <div>The following assignments could not be priced and are missing from this report:</div>
        <ul class="mb-0 pl-4">
          <li v-for="skipped in skippedAssignments" :key="skipped.assignmentId">
            {{ skipped.userFullName }} ({{ skipped.clientName }}): {{ skipped.reason }}
          </li>
        </ul>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SkippedAssignmentsWarning',
  props: [
    'skippedAssignments'
  ]
}
</script>
